const name = 'BasePosition';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, { duration, delay, ...params }, [
        'left',
        'top',
        'x',
        'y',
        'z',
        'bezier',
        'perspectiveOrigin',
        'perspective',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=basePosition.js.map